<template>
    <v-dialog v-model="display" max-width="480px" scrollable>
        <v-card v-if="step == 1">
            <v-card-title class="text-md-subtitle-1 primary-color text-caption">
                行事選択
            </v-card-title>
            <v-card-text class="pa-4 hide-overlay">
                <v-container>
                    <v-row class="border-box">
                        <v-col v-for="shooting in shootings" :key="shooting.id" cols="6">
                            <v-checkbox v-model="selectedShootings" :value="shooting" :label="shooting.name" hide-details
                                dense class="ma-0 pa-0" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="px-4">
                <v-container class="px-3">
                    <v-row justify="space-between">
                        <cancel-dialog-button width="100" @click="closeAutoSelectDialog">
                            キャンセル
                        </cancel-dialog-button>
                        <proceed-dialog-button width="100" @click="confirmShootingSelection">
                            決定
                        </proceed-dialog-button>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
        <v-card v-if="step == 2">
            <v-card-title class="text-md-subtitle-1 primary-color text-caption d-flex justify-space-between">
                <span>自動選定の条件設定</span>
                <span>{{ settings[index].name }} ({{ index + 1 }} / {{ settings.length }})</span>
            </v-card-title>
            <v-card-text class="pa-4 hide-overlay">
                <div class="mb-4">手動選定済みと合わせて、以下の合計枚数になるように自動選定します。</div>
                <div class="d-flex flex-row align-center justify-space-between">
                    <div class="d-flex text-no-wrap">
                        <span class="mx-4">枚数</span>
                        <v-text-field v-model="settings[index].selectedLength" :rules="rules.expectPhotoAmountRules"
                            type="number" min="1" max="999" class="ma-0 pa-0 text-field d-flex align-center"
                            style="max-width: 80px;" />
                    </div>
                    <span class="mx-4">合計枚数　{{ totalSelectedLength }}</span>
                </div>
                <div class="border-box mb-4">
                    <span class="font-weight-bold">優先する写真<br></span>
                    <span>数字ラベルが以下の写真を必ず選ぶ<br></span>
                    <template v-for="(label, i) in settings[index].labels" :keys="lables">
                        <v-icon v-if="i != 0" :color="'#' + label.color_code"
                            :style="{ margin: '8px', opacity: label.isActive ? 1 : 0.2 }" @click="toggleFlag(i)">
                            {{ label.label_icon }}
                        </v-icon>
                    </template>
                </div>
                <div class="border-box mb-4">
                    <span class="font-weight-bold">選ばない写真</span>
                    <div class="d-flex align-center">
                        <v-checkbox v-model="settings[index].deleteLabel" class="ma-0 pa-0 checkbox" />
                        <img class="mr-2" height="14" width="51" src="/images/delete-label.png" />
                        <span>が付いた写真は選ばない</span>
                    </div>
                    <div class="d-flex align-center">
                        <v-checkbox v-model="settings[index].enableFaceLimit" class="ma-0 pa-0 checkbox" />
                        <v-text-field v-model="settings[index].standardLimit" :rules="rules.expectPhotoAmountRules"
                            type="number" min="1" max="999" class="ma-0 pa-0 text-field d-flex align-center"
                            style="max-width: 60px;" @blur="validateExtendedLimit" />
                        <span>人以上の写真はなるべく選ばない</span>
                    </div>
                    <div style="margin-left: 40px;" class="d-flex align-center">
                        <span class="pr-2">※最大</span>
                        <v-text-field v-model="settings[index].extendedLimit" :rules="rules.expectPhotoAmountRules"
                            type="number" min="1" max="999" class="ma-0 pa-0 text-field d-flex align-center"
                            style="max-width: 60px;" @blur="validateExtendedLimit" />
                        <span>人の写真までにする</span>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions class="px-4">
                <v-container class="px-3">
                    <v-row justify="space-between">
                        <v-btn class="button secondary-color" @click="closeAutoSelectDialog">
                            キャンセル
                        </v-btn>

                        <div class="d-flex text-no-wrap">
                            <v-btn v-if="settings.length != 0 && index != 0" class="small-button secondary-color mr-2"
                                @click="index--">
                                戻る
                            </v-btn>
                            <v-btn v-if="settings.length > index + 1" class="small-button primary-color" @click="index++">
                                次へ
                            </v-btn>
                            <v-btn v-else class="button primary-color" @click="executeAutoSelect">
                                <img height="16" width="16" class="mr-2" src="/images/tabler_photo-ai.png" />
                                実行開始
                            </v-btn>
                        </div>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { awaitJobDone } from '../../services/awaitJobDone';

export default {
    props: {
        albumId: {
            type: [Number, String],
            default: 0,
        },
        shootingId: {
            type: [Number, String],
            default: 0,
        },
        shootings: {
            type: Array,
            required: true,
        },
        labels: {
            type: Array,
            required: true,
        },
        completedCallback: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            display: false,
            step: 1,
            selectedShootings: [],
            index: 0,
            settings: [],
            enableFaceLimit: false,
            labelsWithActive: this.labels.map(label => ({
                ...label,
                isActive: false  // isActiveを追加
            })),
            rules: {
                expectPhotoAmountRules: [
                    v => !!v || '入力してください。',
                    v => !v || v && Math.round(v) == v || '整数値を入力してください。',
                    v => !v || v && (v >= 1 && v <= 999) || '1～999の範囲で入力してください。',
                ],
            },
        };
    },
    watch: {
        display(value) {
            if (value) {
                this.initializeAutoSelect();
            }
        }
    },
    methods: {
        autoSelectPhoto(setting) {
            // 選定枚数が入力されているか
            if (!this.rules.expectPhotoAmountRules.every(rule => rule(setting.selectedLength) == true)) {
                return;
            }
            //遺伝的アルゴリズムの処理
            const uri = '/api/algorithm';

            // 自動選定APIのコール
            return axios
                .post(uri, {
                    label: setting.labels,
                    numElements: setting.selectedLength,
                    deleteLabel: setting.deleteLabel,
                    standardLimit: setting.standardLimit,
                    extendedLimit: setting.extendedLimit,
                    enableFaceLimit: setting.enableFaceLimit,
                    albumId: this.albumId,
                    shootingId: setting.id
                })
                .then((res) => {
                    return awaitJobDone(res.data.job_id, true);
                });
        },
        executeAutoSelect() {
            Promise.all(
                this.settings.map(setting => this.autoSelectPhoto(setting))
            )
                .then(() => {
                    this.showInfo('自動選定が完了しました。', '自動選定');
                    this.completedCallback();
                })
                .catch((error) => {
                    console.log('エラー詳細: ' + error);
                    this.showError('自動選定に失敗しました。', '自動選定エラー');
                });
        },
        toggleFlag(i) {
            this.settings[this.index].labels[i].isActive = !this.settings[this.index].labels[i].isActive;
        },
        closeAutoSelectDialog() {
            this.display = false;
        },
        validateExtendedLimit() {
            // extendedLimitがstandardLimitよりも小さい値を入力された場合
            if (Number(this.extendedLimit) < Number(this.standardLimit)) {
                this.extendedLimit = this.standardLimit;
            }
        },
        confirmShootingSelection() {
            // 条件設定に移行
            this.step = 2;

            // 選択した行事分の条件データを作成
            if (this.selectedShootings.length != 0) {
                this.settings = this.selectedShootings.map(shooting => ({
                    id: shooting.id,
                    name: shooting.name,
                    selectedLength: 0,
                    deleteLabel: false,
                    standardLimit: 10,
                    extendedLimit: 12,
                    enableFaceLimit: false,
                    labels: this.labels.map(label => ({
                        ...label,
                        isActive: false,
                    })),
                }));
            }
            else {
                // 現在の行事の条件データを作成
                this.settings = [
                    {
                        id: this.shootingId,
                        name: this.shootings.find(shooting => shooting.id === this.shootingId)?.name,
                        selectedLength: this.selectedLength,
                        deleteLabel: this.deleteLabel,
                        standardLimit: this.standardLimit,
                        extendedLimit: this.extendedLimit,
                        enableFaceLimit: this.enableFaceLimit,
                        labels: this.labelsWithActive,
                    }
                ];
            }
        },
        initializeAutoSelect() {
            this.step = 1;
            this.currentIndex = 0;
            this.selectedShootings = [];
            this.settings = [];
        },
    },
    computed: {
        labelsWithActive() {
            return this.labels ? this.labels.map(label => ({
                ...label,
                isActive: false  // isActiveを追加
            })) : [];
        },
        totalSelectedLength() {
            return this.settings.reduce((sum, setting) => {
                return sum + Number(setting.selectedLength || 0);
            }, 0);
        }
    }
};
</script>
<style>
.text-field .v-input__control {
    display: contents;
}

.text-field input {
    text-align: center;
    padding: 0 0 0 16px !important;
    min-width: 30px;
}

.v-text-field .v-text-field__details {
    max-width: none !important;
}

.v-text-field .v-messages {
    margin-left: 8px;
    white-space: nowrap;
}

.checkbox .v-input__control {
    display: contents;
}

.checkbox .v-input__slot {
    margin-bottom: 0;
}

.small-button {
    width: 70px;
    height: 35px;
    border-radius: 0;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.button {
    width: 150px;
    height: 35px;
    border-radius: 0;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.secondary-color {
    background-color: #FFFFFF !important;
    border: 1px solid #666666 !important;
}

.primary-color {
    background-color: #0F68B1 !important;
    color: #FFF !important;
}

.border-box {
    border: 1px solid #666666;
    padding: 16px;
    border-radius: 4px;
}
</style>